import { useQuery } from '@tanstack/react-query'
import ProcessesApi from '@/infrastructure/api/processes'

// Fetched when the cancel dialog opens and never reused: the answer depends on Shopify's live state.
export function useCancelExchangePreview(processId: string) {
  const query = useQuery({
    queryKey: ['cancelExchangePreview', processId],
    queryFn: ({ signal }) =>
      ProcessesApi.getCancelExchangePreview({ processId }, signal),
    staleTime: 0,
    gcTime: 0,
    retry: false
  })

  return {
    preview: query.data,
    isLoading: query.isLoading,
    isError: query.isError
  }
}
